import {
  isNativeApp
} from './nativeApp';

import {
  getNativeDeviceToken
} from './nativeDeviceAuth';


const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL;

const SUPABASE_KEY =
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;


async function sessionProof(
  session
) {
  if (
    session?.isMaster &&
    session?.masterSessionToken
  ) {
    return {
      kind:
        'master',

      token:
        session.masterSessionToken
    };
  }


  if (isNativeApp()) {
    const token =
      await getNativeDeviceToken();

    if (!token) {
      throw new Error(
        'The saved Student app login is unavailable.'
      );
    }

    return {
      kind:
        'device',

      token
    };
  }


  if (
    session?.webSessionToken
  ) {
    return {
      kind:
        'web',

      token:
        session.webSessionToken
    };
  }


  throw new Error(
    'The Student session is unavailable.'
  );
}


export async function
fetchVisibleStudentNotifications(
  session,
  courseIds,
  limit = 5
) {
  const proof =
    await sessionProof(
      session
    );


  const ids =
    [
      ...new Set(
        (
          Array.isArray(
            courseIds
          )
            ? courseIds
            : []
        )
          .filter(Boolean)
          .map(String)
      )
    ];


  const response =
    await fetch(
      SUPABASE_URL +
        '/rest/v1/rpc/student_visible_notifications',
      {
        method:
          'POST',

        headers: {
          apikey:
            SUPABASE_KEY,

          Authorization:
            'Bearer ' +
            SUPABASE_KEY,

          'Content-Type':
            'application/json'
        },

        body:
          JSON.stringify({
            p_student_id:
              session?.studentId,

            p_session_token:
              proof.token,

            p_session_kind:
              proof.kind,

            p_course_ids:
              ids,

            p_limit:
              limit
          })
      }
    );


  const text =
    await response.text();


  let result =
    null;

  if (text) {
    try {
      result =
        JSON.parse(text);
    } catch {
      result =
        null;
    }
  }


  if (
    !response.ok ||
    result?.ok === false
  ) {
    throw new Error(
      result?.message ||
      'Loading notifications failed.'
    );
  }


  return (
    Array.isArray(
      result?.notifications
    )
      ? result.notifications
      : []
  ).map(
    row => ({
      ...row,

      courses:
        row.courseName
          ? {
              course_titles: {
                name:
                  row.courseName
              }
            }
          : null
    })
  );
}
